import React from 'react';
import { ReactComponent as SeloGreenSteel } from '../assets/selo_green_steel.svg';
import { ReactComponent as SeloGreen } from '../assets/selo_green.svg';
import { ReactComponent as SeloSustentavel } from '../assets/selo_sustentavel.svg';
import { ReactComponent as SeloXCarb } from '../assets/xcarb.svg';
import { ReactComponent as LogoSmart } from "../assets/Espaco_Smart_logo.svg";

const Footer = () => {
  return (
    <footer className="flex flex-col items-center justify-center gap-6">
    <LogoSmart className="w-1/4" />
    <div className="rounded-full py-2 px-16 bg-white">
      <div className="flex flex-col md:flex-row justify-center items-center gap-8">
        <SeloGreenSteel />
        <SeloGreen />
        <SeloSustentavel />
        <SeloXCarb />
      </div>
    </div>
    </footer>
  );
}

export default Footer;